import React, { Component } from 'react';
import { Bar } from 'react-chartjs-2';
import _ from 'underscore';
import { map, startCase } from 'lodash'

import ArticleListings from './article-listings';
import ContactUs from './contact-us';

import './results.css';
import { Others, Leaders, INDUSTRYTYPES, BarColors } from '../../constants';

const withChartSizeControl = (ComponentElement) => {
    return props => (
        <div
            className="chart"
            style={{
                position: "relative"
                , height: `${props.height  }px`
                , width: `${props.width  }px`
            }}
        >
            <ComponentElement {...props} />
        </div>
    );
}

const tooltipModal = (data, title) => {
    const combinedTitle = title.join(' ')
    const value = data.labels.filter(x => x.join(' ') === combinedTitle)[0];
    const indexOfHoveredBar = data.labels.indexOf(value);
    const digitalLeaders = `${data.datasets[0].label  } - ${  data.datasets[0].data[indexOfHoveredBar]}`;
    const average = `${data.datasets[1].label  } - ${  data.datasets[1].data[indexOfHoveredBar]}`;
    const surveyResult = `${data.datasets[2].label  } - ${  data.datasets[2].data[indexOfHoveredBar]}`;
    return (
        `<div>
            <div style="display: flex;" >
                <div style="width:17px; height: 4px; margin: 2px 10px 0 0; background: #000"></div>
                ${digitalLeaders}
            </div>
            <div style="display: flex; margin: 5px 0 0 0;" >
                <div style="width:4px; height: 4px; margin: 2px 2px 0 0; background: #000"></div>
                <div style="width:4px; height: 4px; margin: 2px 2px 0 0; background: #000"></div>
                <div style="width:4px; height: 4px; margin: 2px 10px 0 0; background: #000"></div>
                ${average}
            </div>
            <div style="display: flex; margin: 5px 0 0 0;" >
                <div class="survey-img" style="width:10px; height: 10px; margin: 0 12px 0 3px; background: ${BarColors[startCase(combinedTitle.toLowerCase())]}" ></div>
                ${surveyResult}
            </div>
        </div>`
    );
}

const chartOptions = () => {
    return {
        maintainAspectRatio: false,
        legend: { display: false },
        tooltips: {
            mode: 'point',
            position: 'nearest',
            enabled: false,
            custom(tooltipModel) {

                // Tooltip Element
                let tooltipEl = document.getElementById('chartjs-tooltip');

                // Create element on first render
                if (!tooltipEl) {
                    tooltipEl = document.createElement('div');
                    tooltipEl.id = 'chartjs-tooltip';
                    // tooltipEl.innerHTML = '<table></table>';
                    document.body.appendChild(tooltipEl);
                }

                if(tooltipModel.title) {
                    let div = tooltipModal(this._data, tooltipModel.title);
                    div = `${  div}`;
                    tooltipEl.innerHTML = div;
                }

                // Hide if no tooltip
                if (tooltipModel.opacity === 0) {
                    tooltipEl.style.opacity = 0;
                    return;
                }

                // Set caret Position
                tooltipEl.classList.remove('above', 'below', 'no-transform');
                if (tooltipModel.yAlign) {
                    tooltipEl.classList.add(tooltipModel.yAlign);
                } else {
                    tooltipEl.classList.add('no-transform');
                }

                // `this` will be the overall tooltip
                const position = this._chart.canvas.getBoundingClientRect();

                // Display, position, and set styles for font
                tooltipEl.style.opacity = 1;
                tooltipEl.style.position = 'absolute';
                let tooltipLeft = position.left + window.pageXOffset + tooltipModel.caretX;
                if((tooltipLeft + document.getElementById("chartjs-tooltip").offsetWidth) > window.innerWidth) {
                    tooltipLeft = (tooltipLeft - document.getElementById("chartjs-tooltip").offsetWidth < 0) ? 0 : tooltipLeft - document.getElementById("chartjs-tooltip").offsetWidth;
                }
                tooltipEl.style.left = `${tooltipLeft  }px`;
                tooltipEl.style.top = `${position.top + window.pageYOffset + tooltipModel.caretY  }px`;
                tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
                tooltipEl.style.fontSize = `${tooltipModel.bodyFontSize  }px`;
                tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
                tooltipEl.style.padding = `${tooltipModel.yPadding  }px ${  tooltipModel.xPadding  }px`;
                tooltipEl.style.pointerEvents = 'none';
                tooltipEl.style.borderRadius = '5px';
                tooltipEl.style.boxShadow = '2px 2px 10px rgba(193, 193, 193, 0.9)';
                tooltipEl.style.background = '#fff';
                tooltipEl.style.color = '#000';
            }
        },
        scales: {
            yAxes: [{
                gridLines: { color: '#ddd', lineWidth: 2, drawBorder: false },
                ticks: { min: 0, max: 7, maxTicksLimit: 8, stepSize: 1, padding: 10, fontFamily: "Graphik", fontSize: 14 },
            }],
            xAxes: [{
                display: false,
                id: "bar-x-axis3",
                gridLines: { drawOnChartArea: false, drawTicks: false, color: '#000', lineWidth: 2 },
                ticks: { fontColor: '#000', padding: 20, fontFamily: "Graphik", fontSize: 14 },
                stacked: true,
                type: 'category',
                categoryPercentage: 0.6,
                barPercentage: 0.8,
                /* fontFamily: "Graphik", */
                offset: true
            },
            {
                display: false,
                gridLines: { drawOnChartArea: true, drawTicks: true, color: '#ff0', lineWidth: 2 },
                ticks: { fontColor: '#f0f', padding: 20, fontSize: 14 },
                stacked: true,
                id: "bar-x-axis2",
                type: 'category',
                categoryPercentage: 0.6,
                barPercentage: 0.9,
                offset: true
            },
            {
                display: true,
                gridLines: { drawOnChartArea: false, drawTicks: false, color: '#000', lineWidth: 1 },
                ticks: {
                    fontColor: '#000', padding: 20, fontSize: (window.innerWidth > 768) ? 16 : 10,
                    autoSkip: false,
                    maxRotation: 0,
                    minRotation: 0,
                },
                stacked: true,
                id: "bar-x-axis1",
                type: 'category',
                categoryPercentage: 0.6,
                barPercentage: 0.9,
                maxBarLength: 2,
                offset: true
            }
            ]
        }
    }
}

class Results extends Component {
    constructor(props) {
        super(props);
        this.state = {
            IndustryType: this.props.selectedIndustry,
        }
    }

    componentDidMount() {
        // window.scrollTo(0, 150);
        window.Chart.elements.Rectangle.prototype.draw = function draw() {

            const {ctx} = this._chart;
            const vm = this._view;
            let left; let right; let top; let bottom; let signX; let signY; let borderSkipped;
            let {borderWidth} = vm;
            vm.borderSkipped = "showOnlyTop";
            if (vm.borderSkipped === "showOnlyTop") {
                borderWidth = 0;
            }

            if (!vm.horizontal) {
                // bar
                left = vm.x - vm.width / 2;
                right = vm.x + vm.width / 2;
                top = vm.y;
                bottom = vm.base;
                signX = 1;
                signY = bottom > top ? 1 : -1;
                borderSkipped = vm.borderSkipped || 'bottom';
            } else {
                // horizontal bar
                left = vm.base;
                right = vm.x;
                top = vm.y - vm.height / 2;
                bottom = vm.y + vm.height / 2;
                signX = right > left ? 1 : -1;
                signY = 1;
                borderSkipped = vm.borderSkipped || 'left';
            }

            // Canvas doesn't allow us to stroke inside the width so we can
            // adjust the sizes to fit if we're setting a stroke on the line
            if (borderWidth) {
                // borderWidth shold be less than bar width and bar height.
                const barSize = Math.min(Math.abs(left - right), Math.abs(top - bottom));
                borderWidth = borderWidth > barSize ? barSize : borderWidth;
                const halfStroke = borderWidth / 2;
                // Adjust borderWidth when bar top position is near vm.base(zero).
                const borderLeft = left + (borderSkipped !== 'left' ? halfStroke * signX : 0);
                const borderRight = right + (borderSkipped !== 'right' ? -halfStroke * signX : 0);
                const borderTop = top + (borderSkipped !== 'top' ? halfStroke * signY : 0);
                const borderBottom = bottom + (borderSkipped !== 'bottom' ? -halfStroke * signY : 0);
                // not become a vertical line?
                if (borderLeft !== borderRight) {
                    top = borderTop;
                    bottom = borderBottom;
                }
                // not become a horizontal line?
                if (borderTop !== borderBottom) {
                    left = borderLeft;
                    right = borderRight;
                }
            }

            ctx.beginPath();
            ctx.fillStyle = vm.backgroundColor;
            ctx.strokeStyle = vm.borderColor;
            ctx.lineWidth = borderWidth;

            // Corner points, from bottom-left to bottom-right clockwise
            // | 1 2 |
            // | 0 3 |
            const corners = [
                [left, bottom],
                [left, top],
                [right, top],
                [right, bottom]
            ];

            // Find first (starting) corner with fallback to 'bottom'
            const borders = ['bottom', 'left', 'top', 'right'];
            let startCorner = borders.indexOf(borderSkipped, 0);
            if (startCorner === -1) {
                startCorner = 0;
            }

            function cornerAt(index) {
                return corners[(0 + index) % 4];
            }


            // Draw rectangle from 'startCorner'
            let corner = cornerAt(0);
            ctx.moveTo(corner[0], corner[1]);

            for (let i = 1; i < 4; i+=1) {
                corner = cornerAt(i);
                ctx.lineTo(corner[0], corner[1]);
            }
            if (vm.borderWidth === 2) {
                ctx.setLineDash([5, 5]);
            }
            ctx.fill();

            if (borderWidth) {
                ctx.stroke();
            }

            if (vm.borderSkipped === "showOnlyTop") {

                ctx.beginPath();
                ctx.fillStyle = vm.backgroundColor;
                ctx.strokeStyle = vm.borderColor;
                if (vm.borderWidth === 2) {
                    ctx.lineWidth = 3;
                } else {
                    ctx.lineWidth = 5;

                }

                corner = cornerAt(1);
                ctx.lineTo(corner[0], corner[1]);
                corner = cornerAt(2);
                ctx.lineTo(corner[0], corner[1]);

                ctx.stroke();
            }
        }

    }

    overAllScore (){
        const { statements } = this.props;
        return _.reduce(statements, (total, { answer }) => total + answer, 0) / statements.length;
    }

    chartData() {
        const { statements, selectedIndustry } = this.props;
        const answerValuesByHeader = _.reduce(
            _.groupBy(statements, 'header'),
            (values, answers, header) => {
                const tempValues = values;
                tempValues[header] =_.map(answers, 'answer');
                return tempValues;
            }, {});
        const averages = _.reduce(answerValuesByHeader, (average, answers, header) =>
            Object.assign(average, {
                [header]: _.reduce(answers, (total, answer) => total + answer, 0) / answers.length
            }), {})
        return _.reduce(averages, (chartData, average, header) => {
            chartData.labels.push(header.toUpperCase().split(' '));
            chartData.datasets[2].data.push(average);
            chartData.datasets[2].backgroundColor.push(BarColors[header]);
            return chartData;
        }, {
                labels: [], datasets: [
                    {
                        label: 'Digital Leaders',
                        data: (() => map(Leaders, (value) => value))(),
                        backgroundColor: 'rgba(0, 255, 0, 0)',
                        borderColor: 'rgba(0, 0, 0, 1)',
                        borderWidth: 1,
                        xAxisID: "bar-x-axis2"
                    },

                    {
                        label: `${selectedIndustry  } (Average)`,
                        data: (() => {
                            if (INDUSTRYTYPES[selectedIndustry] && INDUSTRYTYPES[selectedIndustry].overall) {
                                return map(INDUSTRYTYPES[selectedIndustry].overall, (value) => value);
                            }
                                return map(Others, (value) => value);

                        })(),
                        pointBackgroundColor: 'rgba(255, 0, 255, 1)',
                        backgroundColor: 'rgba(255, 0, 255, 0)',
                        borderColor: 'rgba(0, 0, 0, 1)',
                        borderWidth: 2,
                        fill: false,
                        showLines: true,
                        type: 'bar',
                        pointStyle: 'dash',
                        xAxisID: "bar-x-axis2"
                    },
                    {
                        data: [],
                        backgroundColor: [],
                        label: 'Overall Result',
                        xAxisID: "bar-x-axis3",
                        type: 'bar',
                        borderWidth: 1,
                        borderColor: 'rgba(255, 0, 255, 0)',
                    },
                ]
            });
    }

    render() {
        const { selectedIndustry } = this.props;
        const NewBar = withChartSizeControl(Bar);
        return (
            <div className="results-container">
                <div className="navigation">
                    {/* <a onClick={this.props.showHomePage}>
                        <img src="img/svg/left-arrow-red.svg" alt="&lt;" />Retake Survey
                    </a> */}
                </div>
                <div className="results">
                    <div className="question">How prepared is your company to succeed in a digital transformation?</div>
                    <div className="result-chart-container">
                        <div className="chart-legends">
                            <div className="chart-title">OVERALL RESULTS</div>
                            <div className="legends">
                                <div className="legend-text">LEGEND</div>
                                <div className="seperator" />
                                <div className="digital-leaders-img" />
                                <div className="digital-leaders-text">DIGITAL LEADERS</div>
                                <div className="media-average-img" />
                                <div className="media-average-img" />
                                <div className="media-average-img" />
                                <div className="media-average-img" />
                                <div className="media-average-text">{selectedIndustry} (average)</div>
                            </div>
                        </div>
                        <NewBar redraw={false} height={320} data={this.chartData()} options={chartOptions()} />
                        <div className="button">
                            <button type="button" onClick={this.props.showHomePage} className="button-start retake-survey" value="Retake Survey">Retake Survey</button>
                        </div>
                    </div>
                    {/* <div className="overall-score-container">
                        <div className="title">OVERALL SCORE</div>
                        <div className="overall-score">
                            <div className="value">{this.overAllScore()}</div>
                            <div className="text">out of 7</div>
                        </div>
                    </div> */}
                </div>
                <div className="container">
                    <div className="container-3">
                        <ArticleListings jsonConfig={this.props.jsonConfig} selectedProfileType=""
                            data={this.chartData()} selectedIndustryType={INDUSTRYTYPES[this.state.IndustryType]}
                        />
                    </div>
                </div>
                <div className="container">
                    <ContactUs jsonConfig={this.props.jsonConfig} />
                </div>
            </div>
        );
    }
}

export default Results;

// <ArticleListings jsonFMG={this.props.jsonFMG} selectedProfileType={PROFILETYPES.Connected} />



// WEBPACK FOOTER //
// ./src/components/Results/results.js